import React from 'react';
import {connect} from 'react-redux';

const saleWelcome = (props) => {
  return (
    <div className='welcome'>
      <section className='btn-container'>
        <div className='existed-customer' onClick={props.existsCustomerClick}>
          <p>אני לקוח {window.Config.brand_Name_HE}</p>
        </div>
        <div className='new-customer' onClick={props.newCustomerClick}>
          <p>אני עדיין לא לקוח {window.Config.brand_Name_HE}</p>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(saleWelcome);
